var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcShortTimeDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2647 10.4658C26.0861 10.4576 25.9138 10.5247 25.7845 10.6466C25.6572 10.7685 25.5833 10.9372 25.5833 11.114C25.5813 13.4673 25.5813 21.3724 25.5813 23.7419C25.5813 24.1138 25.8871 24.4186 26.2647 24.4186C28.6248 24.4186 36.4171 24.4186 38.8284 24.4186C39.0213 24.4186 39.204 24.3414 39.3374 24.2032C39.4708 24.067 39.5406 23.8821 39.5344 23.6931C39.1835 15.8591 33.2115 10.7787 26.2647 10.4658Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1188 12.2294C30.972 5.08262 19.5346 5.01358 12.5722 11.976C5.60975 18.9384 5.67879 30.3758 12.8256 37.5226C18.7497 43.4467 27.6357 44.5107 34.4623 40.7264C35.3568 40.2306 36.4839 40.5538 36.9797 41.4483C37.4756 42.3428 37.1524 43.4699 36.2579 43.9657C27.99 48.5489 17.3022 47.2371 10.2067 40.1415C1.65812 31.593 1.50021 17.8101 9.95324 9.35707C18.4063 0.904038 32.1891 1.06195 40.7377 9.61052C47.8668 16.7396 49.1575 27.4951 44.4964 35.779C43.9949 36.6704 42.8657 36.9864 41.9744 36.4849C41.0831 35.9833 40.7671 34.8542 41.2686 33.9629C45.1167 27.1237 44.071 18.1816 38.1188 12.2294Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShortTimeDark);
export default __webpack_public_path__ + "static/media/ic_short_time_dark.6c4a4910b5815e16c79f5629ed94583e.svg";
export { ForwardRef as ReactComponent };